import type { IconSvgObject } from './types';

const MicOff02Icon: IconSvgObject = [
  ["path", { d: "M7 7V11C7 13.7614 9.23858 16 12 16C13.1257 16 14.1645 15.628 15.0002 15.0002M8 3.99951C8.91223 2.78534 10.3644 2 12 2C14.7614 2 17 4.23858 17 7V11C17 11.5977 16.8951 12.1709 16.7028 12.7023", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20 11C20 12.4571 19.6807 13.8233 19 15M12 19C7.58172 19 4 15.4183 4 11M12 19V22M12 19C13.8919 19 15.6304 18.3433 17 17.2454M12 22H14.5M12 22H9.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2 2L22 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default MicOff02Icon;
